// Leaflet 1.9 ends a zoom animation on a 250ms timer that keeps running after
// map.remove(). When it fires it reads the map pane remove() already deleted and
// throws "Cannot read properties of undefined (reading '_leaflet_pos')".
// Clearing the in-flight flag first turns that late timer into a no-op.
export const removeMap = map => {
	if (!map) return
	map._animatingZoom = false
	try {
		map.remove()
	} catch {}
}
